module.exports = __webpack_public_path__ + "img/groovepaybr-integration_2.90bd840d.png";